import { Linkable, LinkableImpl } from "./linkable";

export class EntityLink {
  id?: string;
  outwardEntityId: string;
  outwardEntityType: string;
  inwardEntityId: string;
  inwardEntityType: string;
  linkType: string; // LinkedEntityRelationshipType
  linkable?: Linkable | undefined; // @deprecated - use linkedEntity instead
  linkedEntity?: Linkable | undefined; // The resolved linked entity from backend

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.outwardEntityId = payload.outwardEntityId;
      this.outwardEntityType = payload.outwardEntityType;
      this.inwardEntityId = payload.inwardEntityId;
      this.inwardEntityType = payload.inwardEntityType;
      this.linkType = payload.linkType;
      // Support both old 'linkable' and new 'linkedEntity' field names
      this.linkable = payload.linkable ? new LinkableImpl(payload.linkable) : undefined;
      this.linkedEntity = payload.linkedEntity ? new LinkableImpl(payload.linkedEntity) : undefined;
    }
  }

  /**
   * creates EntityLinks from a result array
   * @param result Array of any
   * @returns Array of EntityLink
   */
  static createEntityLinks(result: Array<any>): EntityLink[] {
    const entityLinks = new Array<EntityLink>();
    if (result) {
      result.map((item) => {
        entityLinks.push(new EntityLink(item));
      });
    }
    return entityLinks;
  }
}
